/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Foot_LoopInputs */

const en_mk_foot_loop = /** @type {(inputs: Mk_Foot_LoopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent loop`)
};

const id_mk_foot_loop = /** @type {(inputs: Mk_Foot_LoopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loop agent`)
};

/**
* | output |
* | --- |
* | "Agent loop" |
*
* @param {Mk_Foot_LoopInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_foot_loop = /** @type {((inputs?: Mk_Foot_LoopInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Foot_LoopInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_foot_loop(inputs)
	return en_mk_foot_loop(inputs)
});